import { OrderDto, orderService } from "../../../../../domain";
import { OrderFormListener } from "../../order-form.props";

export const onReview = (orderId: number, listener: OrderFormListener | undefined): Promise<OrderDto | undefined> => {
    return orderService
        .review(orderId)
        .then(res => {
            if (res && listener) {
                listener({type: 'confirmed', sender: res});
            }
            return res;
        })
        .catch(() => {
            return undefined;
        });
}